import * as React from 'react';
import { getPoints, getRewardEarnRule } from '@/service/vip';
import { PointsBehaviorValue } from '../config';
import { getIsLogin } from 'lowcode/utils/getIsLogin';

import type { PointsBehaviorProps } from '../config';

export const usePoints = (locale: string) => {
    const [loading, setLoading] = React.useState(true);
    const [actionPoints, setActionPoints] = React.useState<PointsBehaviorProps | null>(null);

    const fetchData = async (isLogin: boolean) => {
        const keys = Object.keys(PointsBehaviorValue);

        const pointsRes = await getPoints(locale);
        const newContent = { ...pointsRes?.data };

        if (pointsRes?.code !== '0') {
            setLoading(false);
            return;
        }

        // 区分登录/非登录状态
        if (!isLogin) {
            keys.map((item) => {
                if (newContent[item]) {
                    newContent[item] = {
                        value: newContent[item],
                        isFinish: false,
                    };
                }
            });
        } else {
            const ruleRes = await getRewardEarnRule(locale);
            if (ruleRes?.code !== '0') {
                setLoading(false);
                return;
            }

            const ruleContent = [...ruleRes.data];

            keys.map((item) => {
                const [target] = ruleContent.filter((ele: any) => ele.source === item);
                if (newContent[item] && target) {
                    newContent[item] = {
                        value: newContent[item],
                        isFinish: !!target.isFinish,
                    };
                }
            });
        }

        setActionPoints(newContent);
        setLoading(false);
    };

    React.useEffect(() => {
        const isLogin = getIsLogin();

        fetchData(isLogin).finally(() => {
            setLoading(false);
        });
    }, []);

    return { actionPoints, fetchPointtCards: fetchData, loading };
};
